import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LEGAL_DOCS } from '../data/legalDocs';
import '../styles/about.css';
import '../styles/legal.css';

// Groups consecutive list items so bullets render inside one <ul>.
function renderBlocks(blocks) {
  const out = [];
  for (let i = 0; i < blocks.length; i++) {
    const [type, text] = blocks[i];
    if (type === 'li') {
      const items = [];
      while (i < blocks.length && blocks[i][0] === 'li') items.push(blocks[i++][1]);
      i--;
      out.push(<ul key={`ul-${i}`}>{items.map((item, n) => <li key={n}>{item}</li>)}</ul>);
    } else if (type === 'h') {
      out.push(/^\d+\./.test(text) ? <h2 key={i}>{text}</h2> : <h3 key={i}>{text}</h3>);
    } else {
      out.push(<p key={i}>{text}</p>);
    }
  }
  return out;
}

export default function Legal({ doc }) {
  const data = LEGAL_DOCS[doc];
  useEffect(() => { document.title = `${data.title} · DeenLit`; window.scrollTo(0, 0); }, [data.title]);
  return (
    <div className="about-wrapper legal-wrapper">
      <div className="about-inner legal-inner">
        <header className="legal-head">
          <div className="about-eyebrow"><span className="about-ornament">&#10040;</span>DeenLit<span className="about-ornament">&#10040;</span></div>
          <h1 className="legal-title">{data.title}</h1>
          <p className="legal-updated">Last updated: {data.updated}</p>
          <nav className="legal-switch" aria-label="Policies">
            <Link to="/privacy" className={doc === 'privacy' ? 'is-active' : ''}>Privacy Policy</Link>
            <Link to="/terms" className={doc === 'terms' ? 'is-active' : ''}>Terms and Conditions</Link>
          </nav>
        </header>
        <article className="legal-body">{renderBlocks(data.blocks)}</article>
      </div>
    </div>
  );
}
